import { Property, Termin } from '@codefluegel/wowis-rest-typescript-client';
import { useEffect, useState } from 'react';
import { autorun } from 'mobx';

import { useAppointmentsApi } from '../ApiClient';

function useAppointments(currentEstate?: Property) {
  const [activeCategoryIndex, setActiveCategoryIndex] = useState(0);
  const [allAppointments, setAllAppointments] = useState<Termin[]>();

  const appointmentsApi = useAppointmentsApi();

  useEffect(
    () =>
      autorun(() => {
        async function getAppointments() {
          try {
            const { data } = await appointmentsApi.getAllObjektTermine(
              Number(currentEstate?.objId),
            );
            setAllAppointments(data);
          } catch (error) {
            console.log({ error });
          }
        }
        getAppointments();
      }),
    [appointmentsApi, currentEstate?.objId],
  );

  return { activeCategoryIndex, setActiveCategoryIndex, allAppointments };
}

export default useAppointments;
